// extracted by mini-css-extract-plugin
export default {"title":"delete_title__-xUNt","buttonPart":"delete_buttonPart__RbzOe","buttonCancel":"delete_buttonCancel__PgOwW","buttonDelete":"delete_buttonDelete__tNPny"};